import { render, staticRenderFns } from "./ThgBillingSelectionItemContactData.vue?vue&type=template&id=5bdf33a8&"
import script from "./ThgBillingSelectionItemContactData.vue?vue&type=script&lang=ts&"
export * from "./ThgBillingSelectionItemContactData.vue?vue&type=script&lang=ts&"
import style0 from "./ThgBillingSelectionItemContactData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCardActions,VForm,VIcon,VSkeletonLoader,VTextField,VTooltip})
